import { EMAIL_LOGS_LIST } from "../actions/userAction/actionTypes";

const initialObject = {
  loading: false,
  message: "",
  isSuccess: false,
  isDuplicateUser: "null",
  EmailLogsList: [],
};

export const activityReducer = (state = initialObject, action) => {
  switch (action.type) {
    case EMAIL_LOGS_LIST:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        EmailLogsList: action.payload.data?.data,
        totalCount: action.payload.data?.totalCount,
        isSuccess: action.payload.success,
      };
    default:
      return state;
  }
};
